import React from "react";
import {Box, Grid} from "@mui/material";
import {ScheduleActions} from "./ScheduleActions";


export function ScheduleBody() {
	return (
		<Box sx={{flexGrow: 1}}>
			<div className={'section'}>
				<div className={'section-title text-left'}>
					<span className={'label'}/>
					<div className={'divider primary'}/>
				</div>
			</div>
			<div className={'tips'}>
				<Grid container spacing={2}>
					<Grid item xs={12} xl={9}>
						Schedule Body
					</Grid>

					<Grid item xs={12} xl={3} className={'reports'}>
						<ScheduleActions/>
					</Grid>

				</Grid>
			</div>
		</Box>
	)
}
